define('modules/campaigns/campaigns_filter_model',[
  'backbone', '_', 'session'
  ], 
  function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      campaignPeriod: 'all',
      zoneOptions: null,
      searchText: ''
    },
    parse: function(data) {
      return ({
        zoneOptions: {
          active: [],
          options: data.zoneOptions
        },
        searchText: data.searchText || ''
      });
    },
    url: function () {
      return session.get('apiUrl') + 'campaignfilters';
    }
  });

  return Model;
});

